module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-five5.6abc309.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-five5.png
// module id = NalK
// module chunks = 0